export const getBaseUrl = () => {
  const defaultUrl = 'http://localhost:9090/rest'
  // const defaultUrl = 'http://emsqa-api.equadriga.in/emsqa-api/rest'
  let url = process.env.REACT_APP_API_URL || defaultUrl
  return url
}

export const config = {
  baseURL: getBaseUrl(),
  version: '1.0.0',
}

export default config
